import React from 'react';
import { pricingPlans } from '../data/mockData';
import { Button } from './ui/button';
import { Check, ArrowRight } from 'lucide-react';

const PricingSection = ({ onOpenContactForm }) => {
  return (
    <section id="pricing" data-testid="pricing-section" className="py-24 md:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">Pricing</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-5">
            Transparent Pricing. No Surprises.
          </h2>
          <p className="text-base text-[#4B5563] leading-relaxed">
            Every package includes expert attorney support and direct USPTO filing. Pick the level of protection that fits your business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              data-testid={`pricing-card-${plan.id}`}
              className={`relative flex flex-col transition-all duration-500 ${
                plan.recommended
                  ? 'bg-[#0A0F1C] text-white p-8 md:p-10 hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(10,15,28,0.3)]'
                  : 'bg-white border border-[#E5E7EB] p-8 md:p-10 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(10,15,28,0.06)] hover:border-[#002FA7]/30'
              }`}
            >
              {plan.recommended && (
                <span className="absolute top-0 left-0 right-0 bg-[#FF2A00] text-white text-[10px] font-medium uppercase tracking-widest py-1.5 text-center">
                  Most Popular
                </span>
              )}

              <div className={`mb-8 ${plan.recommended ? 'mt-4' : ''}`}>
                <h3 className={`text-sm uppercase tracking-[0.2em] font-medium mb-3 ${plan.recommended ? 'text-gray-400' : 'text-[#4B5563]'}`}>
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1">
                  <span className={`text-5xl font-bold tracking-tighter ${plan.recommended ? 'text-white' : 'text-[#0A0F1C]'}`}>{plan.price}</span>
                </div>
                <p className={`text-xs mt-2 ${plan.recommended ? 'text-gray-500' : 'text-[#4B5563]'}`}>{plan.note}</p>
              </div>

              <ul className="space-y-3 mb-8 h-[210px] overflow-y-auto pr-1 scrollbar-thin">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2.5">
                    <Check className={`w-4 h-4 mt-0.5 flex-shrink-0 ${plan.recommended ? 'text-[#002FA7]' : 'text-[#002FA7]'}`} />
                    <span className={`text-sm ${plan.recommended ? 'text-gray-300' : 'text-[#4B5563]'}`}>{feature}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-auto">
                <Button
                  data-testid={`pricing-cta-${plan.id}`}
                  onClick={onOpenContactForm}
                  className={`w-full font-medium h-11 rounded-none text-sm transition-all duration-300 ${
                    plan.recommended
                      ? 'bg-[#002FA7] text-white hover:bg-[#002280] hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,47,167,0.4)]'
                      : 'bg-[#0A0F1C] text-white hover:bg-[#002FA7] hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,47,167,0.25)]'
                  }`}
                >
                  {plan.buttonText} <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        <p className="text-sm text-[#4B5563] mt-10 max-w-2xl">
          <strong className="text-[#0A0F1C]">Note:</strong> All packages exclude USPTO government fees ($250-$350 per class), paid directly to the USPTO at the time of filing.
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
